import React from "react";
import propTypes from "prop-types";
import { DefaultPageContainer as PageContainer } from "@layout";
import { Text, Container } from "@atoms";
import { HeroHome, ServicesHome, EmployersHome, TestimonialCarousel } from "@organisms";
import { OurReachHome, FooterContact, CbCopy } from "@molecules";

const HomePage = ({ data }) => {
  const { hero, pathways, vimeoEmbed, servicesYouNeed, testimonials, reach, meta } = data;
  return (
    <PageContainer meta={meta}>
      <HeroHome {...hero} />
      {vimeoEmbed && (
        <Container>
          <div className="max-w-2xl mx-auto flex flex-col justify-center my-4 sm:my-8 md:my-0 lg:mb-24">
            <Text className="mx-auto responsive-embed">{vimeoEmbed}</Text>
          </div>
        </Container>
      )}
      <EmployersHome {...pathways} />
      <ServicesHome {...servicesYouNeed} />
      <TestimonialCarousel testimonials={testimonials} />
      <OurReachHome {...reach} />
      <FooterContact />
    </PageContainer>
  );
};

HomePage.defaultProps = {};

HomePage.propTypes = {};

export default HomePage;
